<template>
	<div class="mt-2 position-relative">
		<div class="uploadDocs-caution-font" v-if="label">
			{{ label }}
		</div>

		<Popper
			trigger="clickToToggle"
			:key="reRender"
			@show="showOptions = true"
			@hide="showOptions = false"
			:options="{
				preventOverflow: {
					enabled: true,
				},
				eventsEnabled: false,
			}"
		>
			<template>
				<div v-if="!isMulti" class="tp-radio-group">
					<b-form-group>
						<b-form-radio-group
							v-model="localSelected"
							:options="options"
							value-field="value"
							key-field="key"
							@change="selectOption(localSelected)"
							buttons
							stacked
						>
						</b-form-radio-group>
					</b-form-group>
				</div>
				<div v-else class="tp-checkbox-group">
					<b-form-group>
						<b-form-checkbox-group
							v-model="localSelected"
							:options="options"
							@change="selectOption(localSelected)"
						>
						</b-form-checkbox-group>
					</b-form-group>
				</div>
			</template>
			<template slot="reference">
				<div
					class="laptopinput d-flex align-items-center justify-content-between"
				>
					<span
						class="edu-txt-placeholder"
						v-if="isMulti ? selected.length === 0 : selected === null"
						>Select</span
					>
					<template v-else>
						<span class="edu-txt" v-if="!isMulti">
							{{ options.find((option) => option.value === selected).text }}
						</span>
						<span class="edu-txt" v-else> {{ selected.length }} Selected </span>
					</template>
					<div>
						<img
							:class="showOptions ? 'rotate180' : ''"
							src="../../assets/newdesign/assessPro/bluedownarrow.svg"
							alt=""
						/>
					</div>
				</div>
			</template>
		</Popper>
	</div>
</template>

<script>
import Popper from "vue-popperjs";

export default {
	name: "FilterSelect",
	props: {
		label: {
			type: String,
			required: false,
		},
		options: {
			type: Array,
			required: true,
		},
		isMulti: {
			type: Boolean,
			required: false,
			default: false,
		},
		selected: {
			type: Array | String | Number | null,
			required: true,
		},
	},
	components: {
		Popper,
	},
	data() {
		return {
			showOptions: false,
			localSelected: null,
			reRender: 0,
		};
	},
	created() {
		this.localSelected = this.isMulti ? this.selected || [] : this.selected;
	},
	methods: {
		selectOption(option) {
			if (this.isMulti) {
				this.$emit("update:selected", option);
			} else {
				this.$emit("update:selected", option);
				this.closeFilter();
			}
		},
		closeFilter() {
			this.reRender++;
			this.showOptions = false;
		},
	},
};
</script>

<style></style>
